import React from 'react';
import '../styles/App.css';

const RoomsPage = () => {
  const allRooms = [
    {
      id: 1,
      name: "Superior Rooms",
      description: "Comfortable room with queen-size bed and modern amenities",
      size: "25 m²",
      capacity: "2 adults",
      amenities: ["AC", "Free WiFi", "TV", "Ensuite Bathroom"],
      price: "MK75000/night"
    },
    {
      id: 2,
      name: "Deluxe Room",
      description: "Spacious room with king-size bed, workspace, and garden view",
      size: "35 m²",
      capacity: "2 adults",
      amenities: ["AC", "Free WiFi", "Smart TV", "Minibar", "Coffee Maker"],
      price: "MK90000/night"
    },
    {
      id: 3,
      name: "Executive Suite",
      description: "Luxurious suite with separate living area and private balcony",
      size: "50 m²",
      capacity: "2 adults + 1 child",
      amenities: ["AC", "Free WiFi", "Smart TV", "Minibar", "Coffee Maker", "Safe"],
      price: "MK200000/night"
    },
    {
      id: 4,
      name: "Family Room",
      description: "Perfect for families with two bedrooms and shared living space",
      size: "60 m²",
      capacity: "4 adults",
      amenities: ["AC", "Free WiFi", "2 TVs", "Kitchenette", "Dining Area"],
      price: "MK180000/night"
    },
    {
      id: 5,
      name: "Executive Double",
      description: "Two queen beds perfect for business travelers or friends",
      size: "40 m²",
      capacity: "4 adults",
      amenities: ["AC", "Free WiFi", "TV", "Work Desk", "Minibar"],
      price: "MK150000/night"
    },
    {
      id: 6,
      name: "Accessible Room",
      description: "Specially designed room for guests with mobility needs",
      size: "30 m²",
      capacity: "2 adults",
      amenities: ["AC", "Free WiFi", "TV", "Wheelchair Accessible", "Emergency Call"],
      price: "MK100000/night"
    }
  ];

  const facilities = [
    { icon: "🛏️", title: "Comfortable Beds", description: "Premium mattresses and linens" },
    { icon: "📶", title: "High-Speed WiFi", description: "Free throughout the lodge" },
    { icon: "❄️", title: "Air Conditioning", description: "Individual climate control" },
    { icon: "🍽️", title: "Restaurant", description: "On-site dining available" },
    { icon: "🧺", title: "Laundry Service", description: "Daily housekeeping" },
    { icon: "🅿️", title: "Secure Parking", description: "24/7 monitored parking" },
  ];

  return (
    <main className="rooms-page">
      {/* Hero Section */}
      <section className="rooms-hero">
        <div className="container">
          <div className="rooms-hero-content">
            <h1>Our Rooms & Suites</h1>
            <p>14 uniquely designed rooms offering comfort and style in the heart of Lilongwe</p>
          </div>
        </div>
      </section>

      {/* All Rooms */}
      <section className="all-rooms-section">
        <div className="container">
          <div className="rooms-intro">
            <h2>Accommodation Options</h2>
            <p>Each room at Talali Lodge is designed with your comfort in mind, blending modern amenities with local charm.</p>
          </div>

          <div className="all-rooms-grid">
            {allRooms.map(room => (
              <div key={room.id} className="room-detail-card">
                <div className="room-header">
                  <h3>{room.name}</h3>
                  <span className="room-price">{room.price}</span>
                </div>
                <div className="room-specs">
                  <span className="spec">{room.size}</span>
                  <span className="spec">•</span>
                  <span className="spec">{room.capacity}</span>
                </div>
                <p className="room-description">{room.description}</p>
                <div className="room-amenities">
                  {room.amenities.map((amenity, index) => (
                    <span key={index} className="amenity-tag">{amenity}</span>
                  ))}
                </div>
                <div className="room-actions">
                  <button className="btn-primary">Book Now</button>
                  <button className="btn-outline">View Details</button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Facilities */}
      <section className="facilities-section">
        <div className="container">
          <h2>Hotel Facilities</h2>
          <p className="section-subtitle">Everything you need for a comfortable stay</p>
          
          <div className="facilities-grid">
            {facilities.map((facility, index) => (
              <div key={index} className="facility-card">
                <div className="facility-icon">{facility.icon}</div>
                <h4>{facility.title}</h4>
                <p>{facility.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </main>
  );
};

export default RoomsPage;